export default "__VITE_ASSET__CkMv23KG__"